import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SideBar from "../../components/SideBar";
import RbVSKonGraph from './RbVSKonGraph';
import RbVSKoffGraph from './RbVSKoffGraph';
import ParameterSliders from './InteractiveSliders';
import ParameterSlidersLog from './InteractiveSlidersLog';
import SvsTimeGraph from './SvsTimeGraph';
import LigandCoreGraph from './LigandCore';
import { Accordion, Card } from 'react-bootstrap';

const RbVSKonGraphWithFilters = () => (
    <>
        <ParameterSlidersLog 
            defaultValues={{N: 0.9, T: 0.2e-6, D:10e-6, k_off:0.1}} 
            inputs={[
                {key: 'N', rangeLimit: {min: Math.pow(10,-3), max: Math.pow(10,6)}, type: 'float', },
                {key: 'T', rangeLimit: {min: Math.pow(10, -12), max:Math.pow(10, 12)}, type: 'float', },
                {key: 'D', rangeLimit: {min: Math.pow(10, -12), max:Math.pow(10, 12)}, type: 'float', },
                {key: 'k_off', rangeLimit: {min: Math.pow(10, -12), max:Math.pow(10, 12)}, type: 'float', }]}
            graphComponent={RbVSKonGraph}/>
        </>
)

const RbVSKoffGraphWithFilters = () => (
    <>
        <ParameterSlidersLog 
            defaultValues={{N: 0.9, T: 0.2e-6, D:10e-6, k_on:1e5}} 
            inputs={[
                {key: 'N', rangeLimit: {min: Math.pow(10,-3), max: Math.pow(10,6)}, type: 'float', },
                {key: 'T', rangeLimit: {min: Math.pow(10, -12), max:Math.pow(10, 12)}, type: 'float', },
                {key: 'D', rangeLimit: {min: Math.pow(10, -12), max:Math.pow(10, 12)}, type: 'float', },
                {key: 'k_on', rangeLimit: {min: Math.pow(10, -12), max:Math.pow(10, 12)}, type: 'float', }]}
            graphComponent={RbVSKoffGraph}/>
        </>
)

// DOESNT WORK
const SvsTimeWithFilters = () => (
    <>
        <ParameterSlidersLog 
            defaultValues={{N: 0.9, T: 2e-7, D:1e-5, k_a:1e-2, k_d:2.15e-2} }
            inputs={[
                {key: 'N', rangeLimit: {min: Math.pow(10,-3), max: Math.pow(10,6)}, type: 'float', },
                {key: 'T', rangeLimit: {min: Math.pow(10, -12), max:Math.pow(10, 12)}, type: 'float', },
                {key: 'D', rangeLimit: {min: Math.pow(10, -12), max:Math.pow(10, 12)}, type: 'float', },
                {key: 'k_a', rangeLimit: {min: Math.exp(-6), max: Math.exp(12)}, type: 'float', },
                {key: 'k_d', rangeLimit: {min: Math.exp(-12), max: Math.exp(6)}, type: 'float', }]}
            graphComponent={SvsTimeGraph}/>
        </>
)


const LigandCoreGraphWithFilters = () => (
    <>
        <ParameterSliders 
            defaultValues={{n: 3, m: 5, d_rec:25, d_y:30, K_1: 1e-9, a0: 5, omega_LU: 1, alpha: 1}} 
            inputs={[
                {key: 'n', rangeLimit: {min: 3, max: 30}, type: 'int', },
                {key: 'm', rangeLimit: {min:3, max:60}, type: 'int', },
                {key: 'd_rec', rangeLimit: {min:0, max: 1000}, type: 'float', },
                {key: 'K_1', rangeLimit: {min: Math.pow(10, -9), max: 100}, type: 'float', },
                {key: 'a0', rangeLimit: {min:0.05, max:5}, type: 'float', },
                {key: 'omega_LU', rangeLimit: {min:0, max:1}, type: 'float', }]}
            graphComponent={LigandCoreGraph}/>
        </>
)

const Mathematical = () => {
    const sections = [
        {   sectionId: "graph-1", 
            title: () => (<>Plot of r<i><sub>b</sub></i> vs. <i>k<sub>on</sub></i> for Different k<sub>off</sub> Values</>), 
            graph: RbVSKonGraphWithFilters,
            textContent: () => (<p>
                Here you can simulate the effect of the association constant on the rebinding parameter. 
            </p>)
        },
        {   sectionId: "graph-2", 
        title: () => (<>Plot of r<sub>b</sub> vs. k<sub>off</sub> for Different k<sub>on</sub> Values</>), 
        graph: RbVSKoffGraphWithFilters,
        textContent: () => (<p>
            Here you can simulate the effect of the dissociation constant on the rebinding parameter.
        </p>)
        },
        {   sectionId: "graph-3", 
        title: () => (<>Plot of the total surface probability vs time</>), 
        graph: SvsTimeWithFilters,
        textContent: () => (<p>
            Input thermodynamic parameters for the simulation of the total surface probability.
        </p>)
        },
        {   sectionId: "graph-4", 
        title: () => (<>Influence of ligand core size on the multivalent dissociation contants</>), 
        graph: LigandCoreGraphWithFilters,
        textContent: () => (<p>
            Simulation of the effect of multivalent binding of (n) on the dissociation constant.
        </p>)
        }
        ];

        
    return (
                <Row>    
                    <SideBar sections={sections}/> 
                <Col style={{marginTop: '30px', maxWidth: '600px'}}>
                <h1 id="mathematical" style={{marginBottom: '50px'}}>Mathematical Model</h1> 
                                    <Accordion defaultActiveKey="0">
                        <Card>
                            <Card.Body>
                                <iframe
                                title="Embedded PDF"
                                src="https://static.igem.wiki/teams/4602/wiki/images/sponsors/8bd93649-6cb7-4640-a194-0f3f150f1e61-model.pdf"
                                style={{ width: '100%', height: '400px' }} 
                                ></iframe>
                            </Card.Body>
                        </Card>
                        </Accordion>             
                               {sections.map(section => (<div>
                        <h4 id={section.sectionId}>
                            {typeof section.title === 'string' ? section.title : section.title()}
                        </h4>
                        <section.graph/>
                        <section.textContent/>
                    </div>))}
                    </Col>
                </Row>
    )
}
export default Mathematical;